import { isAdmin, isMediaCenter_tst } from '../../../services/rolesSvc';

export class NewsMode {
  id;

  settings;

  api;

  constructor({
    id, api,
  }) {
    this.id = id;
    this.api = api;
    this.settings = {
      save: {
        title: 'Сохранить изменения',
        action: (dto, postImage) => this.api.postFileFixed(`/news/${!this.id || this.id === 'new' ? 0 : this.id}`, dto, postImage),
        afterActionMessages: ['Новость успешно сохранена'],
      },
      callbackUrl: '/news',
    };
  }

  canEdit = (userCtx) => isAdmin(userCtx) || isMediaCenter_tst(userCtx);

  get = (id) => this.api.get(`/news/${id}`);
}
